<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D1hu7N/tc-custom/9780061753923.jpg?1731838271242" alt="This image is the cover for the book Thirteen Senses"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thirteen Senses
      </h1>
      <p class="bookDescription body article font2">
        <p>A daring memoir of love, magic, adventure, and miracles, Victor Villaseñor's <i>Thirteen Senses</i> continues the exhilarating family saga that began in the widely acclaimed bestseller <i>Rain of Gold,</i> delivering a stunning story of passion, family, and the forgotten mystical senses that stir within us all. </p><p><i>Thirteen Senses</i> begins with the fiftieth wedding anniversary of the aging former bootlegger Salvador and his elegant wife, Lupe. When asked by a young priest to repeat the sacred ceremonial phrase "to honor and obey," Lupe surprises herself and says. "No, I will not say 'obey'. How dare you! You don't talk to me like this after fifty years of marriage and I now knowing what I know!" After the hilarious shock of Lupe's rejection of the ceremony, the Villaseñor family is forced to examine the love that Lupe and Salvador have shared for so many years -- a universal, gut-honest love that will eventually energize and inspire the couple into old age.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Victor Villasenor
      </h2>
      
      <p class="authorDescription body article"><P>Victor Villase&#241;or vive en California en el rancho donde fue criado. Es autor de numerosos obras editoriales y aclamadas obras, entre ellas <I>Lluvia de oro, Jurado: La Gente vs. Juan Corona,</I> y <I>&#194;&#161;Macho!.</I><P>Victor Villase&#241;or's bestselling, critically acclaimed works, as well as his inspiring lectures, have brought him the honor of many awards. Most recently he was selected as the founding chair of the John Steinbeck Foundation. He lives in Oceanside, California.</P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4842f914